import { addAreaShade, updateAreaShadeColor } from './AreaShade'
import Lines3D from './Lines-3D'
import Bar3D from './Bar3D'
import Building3D from './Building-3D'
import Video from './Video'
import Image from './Image'
import Point from './Point'
import Model from './Model'
/**
 * mapbox 相关操作
 */
export default function(mapbox, deck, chart) {
  this.mapbox = mapbox
  this.deck = deck
  this.chart = chart
  this.addAreaShade = addAreaShade
  this.updateAreaShadeColor = updateAreaShadeColor
  this.addLines3D = Lines3D
  this.newBar3D = function(id, pk, option) {
    return new Bar3D(this.mapbox, id, pk, option)
  }
  this.addBuilding3D = Building3D
  this.addVideo = Video
  this.addImage = Image
  this.addPoint = Point
  this.addModel = Model
}



// WEBPACK FOOTER //
// ./src/framework/map/layer/index.js